import { PackagesLabelType } from "@shared/enums/packages-label-type";
import { PackagesType } from "@shared/enums/packages-type";

export interface Formula {
  id: number;
  code: string;
  label: string;
}
// Add the missing line below if needed
export const formulaValues: Formula[] = [
  { id: 1, code: PackagesType.Confort, label: PackagesLabelType.Confort },
  { id: 2, code: PackagesType.ConfortPlus, label: PackagesLabelType.ConfortPlus },
  { id: 6, code: PackagesType.Parisienne, label: PackagesLabelType.Parisienne },
  { id: 7, code: PackagesType.Solidaire, label: PackagesLabelType.Solidaire },
  { id: 9, code: PackagesType.ProtectionJuridique, label: PackagesLabelType.ProtectionJuridique },
  { id: 10, code: PackagesType.Tourcoing, label: PackagesLabelType.Tourquennoise },
  { id: 11, code: PackagesType.Lilloise, label: PackagesLabelType.Lilloise },

  // SA
  { id: 12, code: PackagesType.Tranquilite80, label: PackagesLabelType.Tranquilite80 },
  { id: 13, code: PackagesType.Tranquilite65, label: PackagesLabelType.Tranquilite65 },
  { id: 14, code: PackagesType.Securite, label: PackagesLabelType.Securite },

  { id: 15, code: PackagesType.Grenobloise, label: PackagesLabelType.Grenobloise },
  { id: 16, code: PackagesType.Cristolienne, label: PackagesLabelType.Cristolienne },
  { id: 17, code: PackagesType.Etudiante, label: PackagesLabelType.Etudiante },
  { id: 18, code: PackagesType.Marseille, label: PackagesLabelType.Marseillaise },

  {id: 23 , code: PackagesType.Bailleur_Sociaux, label: PackagesLabelType.Bailleur_Sociaux},


];

export function getFormulaBy(predicate: (formula: Formula) => boolean): Formula | undefined {
  return formulaValues.find(predicate);
}

export function getFormulasBy(predicate: (formula: Formula) => boolean): Formula[] {
  return formulaValues.filter(predicate);
}
